import { useState, useRef, useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaClipboard } from 'react-icons/fa'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [usuario, setUsuario] = useState(null)
  const [empresa, setEmpresa] = useState("SIN EMPRESA")
  const [menuVisible, setMenuVisible] = useState(false)

  const menuRef = useRef(null)
  const userRef = useRef(null)

  useEffect(() => {
    setUsuario(JSON.parse(localStorage.getItem('user')) || null)
    if (localStorage.getItem('empresa')==='0') {
      setEmpresa("SIN EMPRESA")
    }
    else {
      setEmpresa(localStorage.getItem('razon_social'))
    }
}, [])

const seccionActual = useMemo(() => {
  const segmentos = location.pathname.split('/').filter(Boolean)
  return segmentos[segmentos.length - 1]?.toUpperCase().replace(/-/g, ' DE ') || "SECCIÓN DESCONOCIDA"
}, [location.pathname])

const toggleMenu = () => setMenuVisible(!menuVisible)
const closeMenu = () => setMenuVisible(false)

useEffect(() => {
  const handleClickOutside = (e) => {
    if (!menuRef.current?.contains(e.target) && !userRef.current?.contains(e.target)) closeMenu()
  }
  document.addEventListener('click', handleClickOutside)
  return () => document.removeEventListener('click', handleClickOutside)
}, [])

return (
  <div className="flex justify-between items-center h-[50px] border-b border-gray-500 px-4 bg-gray-900">
    <span className="flex items-center text-base font-semibold text-white px-6 py-2 border-b-4 border-teal-500 md:ml-[223px]">
      <FaClipboard className="w-4 h-4 sm:w-5 sm:h-5 text-white mr-2" />
      {seccionActual}
    </span>

    <div className="relative z-10 font-semibold text-white">
      {usuario ? (
        <div className="flex gap-10">
          <span className="font-bold text-[#6cb1d8]">{empresa}</span>
          <span ref={userRef} onClick={toggleMenu} className="cursor-pointer font-bold flex">
            <span className="text-teal-500 mr-1">{usuario.nombres_usuario}</span> {usuario.apellidos_usuario}
          </span>
          {menuVisible && (
            <div ref={menuRef} className="absolute right-0 mt-8 w-48 bg-gray-800 text-white shadow-lg rounded-lg border border-teal-500">
              <ul>
                <li><button onClick={() => { navigate('/user/datos-usuario'); closeMenu(); }} className="w-full text-left px-4 py-2 hover:bg-teal-600">Editar datos</button></li>
                <li><button onClick={() => { navigate('/user/clave-usuario'); closeMenu(); }} className="w-full text-left px-4 py-2 hover:bg-teal-600">Cambiar clave</button></li>
              </ul>
            </div>
          )}
        </div>
      ) : <span className="text-red-500">Usuario no autenticado</span>}
    </div>
  </div>
)
}

export default Header
